var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockCountdownRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 17.083A13.015 13.015 0 1114.918 3a1.003 1.003 0 11.165 2A11.015 11.015 0 1027 16.918a1.004 1.004 0 012 .165zM15 9v7a1 1 0 001 1h7a1 1 0 000-2h-6V9a1 1 0 00-2 0zm5-3a1.5 1.5 0 100-2.999 1.5 1.5 0 000 3zm4.5 3a1.5 1.5 0 100-2.999 1.5 1.5 0 000 3zm3 4.5a1.5 1.5 0 100-2.999 1.5 1.5 0 000 3z"
  })));
}
export default SvgClockCountdownRegular;